import React, { useEffect, useState } from 'react';
import withAuth from '../Utils/withAuth';
import { Flex, Stack, Text, Grid, Image, Link, Button } from '@chakra-ui/react';
import Footer from '../Components/General/Footer';
import { useHistory } from 'react-router-dom';
import ContentHeader from '../Components/General/ContentHeader';
import downloadFile from '../Images/icon/download_file.svg';
import no_cert from '../Images/icon/no_cert.svg';
import { paction } from '../Utils/api';
// 0511 getTransaction api
import { getTransactionInfo } from '../Utils/api';
import '../Styles/theme/blockchain_window.css';

function Home() {
  const history = useHistory();
  const [data, setData] = useState([]);
  const [amount, setAmount] = useState(0);
  useEffect(() => {
    const p_no = JSON.parse(sessionStorage.getItem('place_no') || '{}');
    const c_no = JSON.parse(sessionStorage.getItem('company_no') || '{}');
    paction(p_no, c_no).then((res) => {
      setAmount(res.data.length);
      setData(res.data);
    });
  }, []);
  // 0511
  const [showModel, setShowModel] = useState(false);
  const [tx_place_no, setTxPlaceNo] = useState('');
  const [tx_company_no, setTxCompanyNo] = useState('');
  const [tx_paction_no, setTxPactionNo] = useState('');
  const [tx_TransactionHash, setTxHash] = useState('');
  const [tx_block_hash, setTxBlockHash] = useState('');
  const [tx_block_number, setTxBlockNumber] = useState('');
  const [tx_raw_data, setTxRawData] = useState('');
  const handleLinkClick = (transaction_hash) => {
    getTransactionInfo(transaction_hash)
      .then((response_data) => {
        setTxPlaceNo(response_data.place_no);
        setTxCompanyNo(response_data.company_no);
        setTxPactionNo(response_data.paction_no);
        setTxBlockHash(response_data.block_hash);
        setTxBlockNumber(response_data.block_number);
        setTxRawData(response_data.raw_data);
        setTxHash(transaction_hash);
      });
  };
  const downloadCert = (certName) => {
    const rawBase = (process.env.REACT_APP_END_POINT || '/backend').replace(/\/+$/, '');
    const baseURL = rawBase.endsWith('/backend') ? rawBase : `${rawBase}/backend`;
    const pdfUrl = `${baseURL}/paction/pdf?paction_no=${encodeURIComponent(certName)}`;
    fetch(pdfUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `${certName}.pdf`;
        link.click();
      })
      .catch(console.error);
  };
  const Cert = (props) => (
    <Stack
      maxH={'350px'}
      bgColor={'white'}
      border="1px solid #EEEEEE"
      borderRadius={'12px'}
      p={3}
      mb={5}
      overflow="hidden"
    >
      <Flex
        fontWeight={'semibold'}
        fontSize="17px"
        justify={'space-between'}
        alignItems={'center'}
      >
        <Text
          cursor={'pointer'}
          onClick={() =>
            history.push({
              pathname: `/cert/${props.cert.paction_no}`,
              state: {
                certName: props.cert.paction_no,
                people_ID: props.cert.company_no,
                place_ID: props.cert.place_no,
                area: props.cert.location,
                tx: props.cert.tx_hash,
              },
            })
          }
        >
          {props.cert.paction_no}
        </Text>
        <Button
          variant="normal"
          fontWeight={'normal'}
          leftIcon={<Image src={downloadFile} />}
          onClick={() => downloadCert(props.cert.paction_no)}
        >
          下載
        </Button>
      </Flex>
      <Flex color={'grey.700'}>{props.cert.emails}</Flex>
      <Flex justify={'space-between'}>
        <Flex alignItems="center">
          <Text mr="7px">Tx</Text>

          <Link onClick={() => { handleLinkClick('0x' + props.cert.tx_hash); setShowModel(true); }}>
            {'0x' + props.cert.tx_hash}

          </Link>
        </Flex>
        <Text color={'grey.700'}>{props.cert.issue_date.substr(0, 10)}</Text>
      </Flex>
      <hr />
      <Image borderRadius={'12px'} src={props.cert.screenshot_pdf} />
    </Stack>
  );
  // 0524 add slice raw data function
  const splitStringWithBrackets = (str, maxLength) => {
    const chunks = [];
    let start = 0;
    while (start < str.length) {
      const end = start + maxLength;
      chunks.push(`[${str.slice(start, end)}]`);
      start = end;
    }
    return chunks.map((chunk, index) => (
      <React.Fragment key={index}>
        {chunk}
        <br />
      </React.Fragment>
    ));
  };
  return (
    <Stack h="100%" w="100%" overflowY="scroll" bgColor={'#F4F6F7'}>
      <ContentHeader
        tabs={[
          { label: '我的證書', path: '/home' },
          { label: '分享管理', path: '/licenseshare' },
          { label: '接收紀錄', path: '/recipientshare' }
        ]}
      />
      {showModel && (
        <div className="overlay_blockchain">
          <div className="modal_blockchain" onClick={(e) => e.stopPropagation()}>
            <div className="header_blockchain">
              <span className="title_blockchain">鏈上資訊瀏覽器測試</span>
            </div>
            <div className="body_blockchain">
              <div className="left-column">
                <div className="row_blockchain">
                  <span className="label_blockchain">區塊號碼:</span>
                  <br />
                  <span className="value_blockchain">{tx_block_number}</span>
                </div>
                <div className="row_blockchain">
                  <span className="label_blockchain">證書編號:</span>
                  <br />
                  <span className="value_blockchain">{tx_paction_no}</span>
                </div>
                <div className="row_blockchain">
                  <span className="label_blockchain">運作場所管編:</span>
                  <br />
                  <span className="value_blockchain">{tx_place_no}</span>
                </div>
                <div className="row_blockchain">
                  <span className="label_blockchain">運作人管編:</span>
                  <br />
                  <span className="value_blockchain">{tx_company_no}</span>
                </div>
              </div>
              <div className="right-column">
                <div className="row_blockchain">
                  <span className="label_blockchain">區塊 hash 值:</span>
                  <br />
                  <span className="value_blockHash_Tx_blockchain">{tx_block_hash}</span>
                </div>
                <div className="row_blockchain">
                  <span className="label_blockchain">鏈上 Tx:</span>
                  <br />
                  <span className="value_blockHash_Tx_blockchain">{tx_TransactionHash}</span>
                </div>
                <div className="row_blockchain">
                  <span className="label_blockchain">16進位值:</span>
                  <div className="value_hexRawData_blockchain raw-data_blockchain">
                    {splitStringWithBrackets(tx_raw_data, 50)}
                  </div>
                </div>
              </div>
            </div>
            <div className="footer_blockchain">
              <button className="exit-button_blockchain" onClick={(e) => { e.stopPropagation(); setShowModel(false); }}>離開瀏覽器</button>
            </div>
          </div>
        </div>
      )}

      {amount == 0 && (
        <Flex flexGrow={1} justifyContent="center">
          <Stack justifyContent="center" alignItems="center">
            <Image src={no_cert} w="200px" h="200px" />
            <Text color="#DCDDDD">您尚未擁有任何證書</Text>
          </Stack>
        </Flex>
      )}
      {amount > 0 && (
        <Stack>
          <Grid
            py={5}
            px={10}
            flexGrow={1}
            templateColumns="repeat(auto-fill,minmax(470px,1fr))"
            gap={6}
          >
            {data &&
              data.map((cert) => <Cert cert={cert} key={cert.paction_no} />)}
          </Grid>
          {/* 新增提示文字，放在證書列表之後 */}
          <Text color="#DCDDDD" fontSize="24px" textAlign="center" mt={4}>
            持續新增中
          </Text>
        </Stack>
      )}
      <Footer />
    </Stack>
  );
}

export default withAuth(Home);